import uamClientService from '../uam/uamClientService';
import {log} from '../log';
import {setFindMyDeviceDuration} from '../../state/slices/iotData';

let onUpdateSettingsSuccessHandler;
let onHolderUpdateSettingsSuccessHandler;
let onUpdateSettingsErrorHandler;
let onHolderUpdateSettingsErrorHandler;

let onResetDeviceSuccessHandler;
let onHolderResetDeviceSuccessHandler;
let onResetDeviceErrorHandler;
let onHolderResetDeviceErrorHandler;

let onFindMyDeviceSuccessHandler;
let onFindMyDeviceErrorHandler;

let onAutoCleanSuccessHandler;
let onAutoCleanErrorHandler;

export const updateDeviceSetting = async ({data, isHolder, onError, onSuccess}) => {
    if (isHolder) {
        onHolderUpdateSettingsSuccessHandler = onSuccess;
        onHolderUpdateSettingsErrorHandler = onError;
    } else {
        onUpdateSettingsSuccessHandler = onSuccess;
        onUpdateSettingsErrorHandler = onError;
    }

    return uamClientService.updateUamSettings(data, isHolder);
};

export const resetMyDevice = async ({isHolder, onError, onSuccess}) => {
    if (isHolder) {
        onHolderResetDeviceSuccessHandler = onSuccess;
        onHolderResetDeviceErrorHandler = onError;
    } else {
        onResetDeviceSuccessHandler = onSuccess;
        onResetDeviceErrorHandler = onError;
    }

    return uamClientService.resetMyDevice(isHolder);
};

export const findMyDevice = async ({action, durationSeconds = 30, onError, onSuccess}) => {
    onFindMyDeviceSuccessHandler = onSuccess;
    onFindMyDeviceErrorHandler = onError;

    const data = {
        action,
        durationSeconds,
    };

    setFindMyDeviceDuration(durationSeconds);

    return uamClientService.findMyDevice(data);
};

export const autoClean = async ({onError, onSuccess}) => {
    onAutoCleanSuccessHandler = onSuccess;
    onAutoCleanErrorHandler = onError;

    return uamClientService.autoClean();
};

const logSetting = (isHolder, error, actionName) => {
    const status = error ? 'Failed' : 'Success';
    log.info(
        `End ${actionName} process. ${status}. isHolder: ${isHolder}.${!!error ? ' error: ' + JSON.stringify(error) + '.' : ''}`
    );
};

const onUpdateSettingsFinish = (isHolder, error) => {
    logSetting(isHolder, error, 'updateSettings');

    if (error) {
        return isHolder ? onHolderUpdateSettingsErrorHandler?.(error) : onUpdateSettingsErrorHandler?.(error);
    }

    return isHolder ? onHolderUpdateSettingsSuccessHandler?.() : onUpdateSettingsSuccessHandler?.();
};

const onResetDeviceFinish = (isHolder, error) => {
    logSetting(isHolder, error, 'resetDevice');

    if (error) {
        return isHolder ? onHolderResetDeviceErrorHandler?.(error) : onResetDeviceErrorHandler?.(error);
    }

    return isHolder ? onHolderResetDeviceSuccessHandler?.() : onResetDeviceSuccessHandler?.();
};

const onFindMyDeviceFinish = (error, endTs) => {
    logSetting(false, error, 'findMyDevice');

    return error ? onFindMyDeviceErrorHandler?.(error) : onFindMyDeviceSuccessHandler?.(endTs);
};

const onAutoCleanFinish = (error) => {
    logSetting(false, error, 'autoClean');

    return error ? onAutoCleanErrorHandler?.(error) : onAutoCleanSuccessHandler?.();
};

export default {onUpdateSettingsFinish, onResetDeviceFinish, onFindMyDeviceFinish, onAutoCleanFinish};
